export default {
  uiFrameworkUrl: window.edsPlayground.uiFrameworkUrl,
  trustedSources: window.edsPlayground.trustedSources,
  pageTitle: 'Emarsys Design System Playground'
};
